module.exports = __webpack_public_path__ + "static/media/pic1.572c3222.jpg";